'use strict';

angular.module('theme').component('updatePaymethodNotice', {
	templateUrl: 'component/update-paymethod-notice.html',
	bindings: {
		required: '<',
		topBar: '<'
	},
	controller: function($cookies, $window, CustomerService) {
		var self = this;

		self.$onInit = function() {
			if (self.required && moment().isAfter('2021-01-30')) {
				self.requiredNotice = true;
			}
			self.showNotice = false;
			self.showTopBar = false;
			self.checkPaymethod();
		};

		this.checkPaymethod = function() {
			CustomerService.get().then(function(customer) {
				if (customer && customer.category !== 'special' && customer.payMethod !== 'notklarna' && customer.payMethod !== 'klarna') {

					if (typeof self.topBar != 'undefined') {
						self.showTopBar = self.topBar;
					} else {
						self.showTopBar = true;
					}

					var body = angular.element(document.querySelector('body'));
					body.addClass('top-notice');

					var notice = $cookies.getObject('paymethod-notice');

					if (self.requiredNotice || !notice) {
						self.showNotice = true;
					}
				}
			});
		};

		this.changePaymethod = function() {
			$cookies.putObject('paymethod-notice', true, {
				path: '/'
			});
			
			$window.location.href = '/mypage/account/?selected=billing';
		};

		this.dismiss = function() {
			$cookies.putObject('paymethod-notice', true, {
				path: '/'
			});
		};

	}
});
